import React from 'react';

const HeaderSettingsPanel = ({ theme, handleChange }) => {
    return (
        <div className="notifications-panel mt-4">
            <div className="notifications-panel__header">
                <span className="d-flex align-items-center gap-2">
                    <i className="bi bi-layout-header"></i>
                    Header Settings
                </span>
            </div>
            <div className="notifications-panel__body">
                {/* General Header Settings */}
                <div className="row mb-3">
                    <div className="col-md-3">
                        <label className="form-label">Layout</label>
                        <select
                            className="form-control"
                            value={theme.header.layout}
                            onChange={(e) => handleChange('header', null, 'layout', e.target.value)}
                        >
                            <option value="default">Default</option>
                            <option value="minimal">Minimal</option>
                            <option value="centered">Centered</option>
                            <option value="stacked">Stacked</option>
                        </select>
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Sticky</label>
                        <select
                            className="form-control"
                            value={theme.header.sticky}
                            onChange={(e) => handleChange('header', null, 'sticky', e.target.value === 'true')}
                        >
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Show Border</label>
                        <select
                            className="form-control"
                            value={theme.header.showBorder}
                            onChange={(e) => handleChange('header', null, 'showBorder', e.target.value === 'true')}
                        >
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Background Color</label>
                        <div className="input-group">
                            <input
                                type="color"
                                className="form-control form-control-color"
                                value={theme.header.backgroundColor === 'auto' ? theme.theme.colors.primary : theme.header.backgroundColor}
                                onChange={(e) => handleChange('header', null, 'backgroundColor', e.target.value)}
                                style={{ width: '50px' }}
                            />
                            <input
                                type="text"
                                className="form-control"
                                value={theme.header.backgroundColor}
                                onChange={(e) => handleChange('header', null, 'backgroundColor', e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Text Color</label>
                        <div className="input-group">
                            <input
                                type="color"
                                className="form-control form-control-color"
                                value={theme.header.textColor}
                                onChange={(e) => handleChange('header', null, 'textColor', e.target.value)}
                                style={{ width: '50px' }}
                            />
                            <input
                                type="text"
                                className="form-control"
                                value={theme.header.textColor}
                                onChange={(e) => handleChange('header', null, 'textColor', e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                <hr className="my-3" />

                {/* Logo Settings */}
                <h6 className="fw-semibold mb-3">Logo Settings</h6>
                <div className="row mb-3">
                    <div className="col-md-3">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="showLogo"
                                checked={theme.header.showLogo}
                                onChange={(e) => handleChange('header', null, 'showLogo', e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="showLogo">
                                Display Logo
                            </label>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Logo Position</label>
                        <select
                            className="form-control"
                            value={theme.header.logoPosition}
                            onChange={(e) => handleChange('header', null, 'logoPosition', e.target.value)}
                        >
                            <option value="left">Left</option>
                            <option value="center">Center</option>
                            <option value="right">Right</option>
                        </select>
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Logo Position (Mobile)</label>
                        <select
                            className="form-control"
                            value={theme.header.logoPositionMobile}
                            onChange={(e) => handleChange('header', null, 'logoPositionMobile', e.target.value)}
                        >
                            <option value="left">Left</option>
                            <option value="center">Center</option>
                            <option value="right">Right</option>
                        </select>
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Logo Height</label>
                        <input
                            type="text"
                            className="form-control"
                            value={theme.header.logoHeight}
                            onChange={(e) => handleChange('header', null, 'logoHeight', e.target.value)}
                        />
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Logo Height (Mobile)</label>
                        <input
                            type="text"
                            className="form-control"
                            value={theme.header.logoHeightMobile}
                            onChange={(e) => handleChange('header', null, 'logoHeightMobile', e.target.value)}
                        />
                    </div>
                </div>

                <hr className="my-3" />

                {/* Clinic Name Settings */}
                <h6 className="fw-semibold mb-3">Clinic Name Settings</h6>
                <div className="row mb-3">
                    <div className="col-md-3">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="showClinicName"
                                checked={theme.header.showClinicName}
                                onChange={(e) => handleChange('header', null, 'showClinicName', e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="showClinicName">
                                Display Clinic Name
                            </label>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Name Position</label>
                        <select
                            className="form-control"
                            value={theme.header.clinicNamePosition}
                            onChange={(e) => handleChange('header', null, 'clinicNamePosition', e.target.value)}
                        >
                            <option value="left">Left</option>
                            <option value="center">Center</option>
                            <option value="right">Right</option>
                        </select>
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Name Size</label>
                        <input
                            type="text"
                            className="form-control"
                            value={theme.header.clinicNameSize}
                            onChange={(e) => handleChange('header', null, 'clinicNameSize', e.target.value)}
                        />
                    </div>
                </div>

                <hr className="my-3" />

                {/* Contact Info Settings */}
                <h6 className="fw-semibold mb-3">Contact Info Settings</h6>
                <div className="row mb-3">
                    <div className="col-md-3">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="showContactInfo"
                                checked={theme.header.showContactInfo}
                                onChange={(e) => handleChange('header', null, 'showContactInfo', e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="showContactInfo">
                                Display Contact Info
                            </label>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="showContactInfoMobile"
                                checked={theme.header.showContactInfoMobile}
                                onChange={(e) => handleChange('header', null, 'showContactInfoMobile', e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="showContactInfoMobile">
                                Show on Mobile
                            </label>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Contact Position</label>
                        <select
                            className="form-control"
                            value={theme.header.contactInfoPosition}
                            onChange={(e) => handleChange('header', null, 'contactInfoPosition', e.target.value)}
                        >
                            <option value="right">Right</option>
                            <option value="left">Left</option>
                        </select>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-md-3">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="showAddress"
                                checked={theme.header.showAddress}
                                onChange={(e) => handleChange('header', null, 'showAddress', e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="showAddress">
                                Show Address
                            </label>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="showPhone"
                                checked={theme.header.showPhone}
                                onChange={(e) => handleChange('header', null, 'showPhone', e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="showPhone">
                                Show Phone
                            </label>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="showFax"
                                checked={theme.header.showFax}
                                onChange={(e) => handleChange('header', null, 'showFax', e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="showFax">
                                Show Fax
                            </label>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Contact Info Text Color</label>
                        <div className="input-group">
                            <input
                                type="color"
                                className="form-control form-control-color"
                                value={theme.header.contactInfoTextColor}
                                onChange={(e) => handleChange('header', null, 'contactInfoTextColor', e.target.value)}
                                style={{ width: '50px' }}
                            />
                            <input
                                type="text"
                                className="form-control"
                                value={theme.header.contactInfoTextColor}
                                onChange={(e) => handleChange('header', null, 'contactInfoTextColor', e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Contact Info Text Size</label>
                        <input
                            type="text"
                            className="form-control"
                            value={theme.header.contactInfoTextSize}
                            onChange={(e) => handleChange('header', null, 'contactInfoTextSize', e.target.value)}
                        />
                    </div>
                </div>

                <hr className="my-3" />

                {/* Social Icons Settings */}
                <h6 className="fw-semibold mb-3">Social Icons Settings</h6>
                <div className="row mb-3">
                    <div className="col-md-3">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="showSocialIcons"
                                checked={theme.header.showSocialIcons}
                                onChange={(e) => handleChange('header', null, 'showSocialIcons', e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="showSocialIcons">
                                Display Social Icons
                            </label>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="showSocialIconsMobile"
                                checked={theme.header.showSocialIconsMobile}
                                onChange={(e) => handleChange('header', null, 'showSocialIconsMobile', e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="showSocialIconsMobile">
                                Show on Mobile
                            </label>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Social Icons Position</label>
                        <select
                            className="form-control"
                            value={theme.header.socialIconsPosition}
                            onChange={(e) => handleChange('header', null, 'socialIconsPosition', e.target.value)}
                        >
                            <option value="right">Right</option>
                            <option value="left">Left</option>
                            <option value="contactLeft">Left of Contact Info</option>
                            <option value="contactRight">Right of Contact Info</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeaderSettingsPanel;
